import React from "react";
import { ShieldCheck } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faq, guarantees } from "../mock";

const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-28 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-[1fr_1.3fr] gap-12 lg:gap-16">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4">
              Questions fréquentes
            </p>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-neutral-900 leading-tight">
              Tout ce qu'il faut savoir <span className="text-brand">avant de commencer.</span>
            </h2>
            <div className="mt-8 bg-white border border-neutral-200 rounded-2xl p-6">
              <p className="text-xs font-semibold tracking-widest text-neutral-500 uppercase mb-4">Nos garanties</p>
              <ul className="space-y-3">
                {guarantees.map((g) => (
                  <li key={g} className="flex items-start gap-3 text-sm text-neutral-700">
                    <ShieldCheck size={18} className="text-brand shrink-0 mt-0.5" />
                    {g}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Accordion type="single" collapsible className="space-y-3">
            {faq.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="bg-white border border-neutral-200 rounded-xl px-5"
              >
                <AccordionTrigger className="text-left font-semibold text-neutral-900 hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-neutral-600 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
